module.exports = "https://cdn.hellotech.com/client-assets/yale_locks_tablet_9a9bb5083e6765a5679d35c57ceca9b7.webp";